import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Dynamically generated tool list based on available tool pages
const toolFiles = [
  { path: '/thumbnail-downloader', label: 'Thumbnail Downloader' },
  { path: '/title-description-extractor', label: 'Title & Description Extractor' },
  { path: '/embed-code-generator', label: 'Embed Code Generator' },
  { path: '/timestamp-link-generator', label: 'Timestamp Link Generator' },
  // Add more tools here if routed and available
];

const TryOurTools: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const otherTools = toolFiles.filter(tool => tool.path !== currentPath);

  if (otherTools.length === 0) return null;

  return (
    <div className="mt-12 mb-8 max-w-xl mx-auto bg-light-card dark:bg-dark-card rounded-lg shadow border border-light-border dark:border-dark-border p-6">
      <h2 className="text-xl font-bold mb-4 text-light-text dark:text-dark-text text-center">Try Our Other Tools</h2>
      <ul className="flex flex-col gap-3">
        {otherTools.map(tool => (
          <li key={tool.path}>
            <Link
              to={tool.path}
              className="block w-full text-center px-4 py-2 rounded-lg bg-light-accent text-white dark:bg-dark-accent dark:text-dark-background font-semibold text-base hover:bg-light-accent_hover dark:hover:bg-dark-accent_hover transition-colors"
            >
              {tool.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TryOurTools; 